.downloadButtonsWrapper {
	@apply yst-flex yst-items-center yst-justify-end yst-space-x-2;
}

.downloadButtonIcon {
	@apply yst-w-4 yst-h-4 yst-mr-1;
}
